import { render, staticRenderFns } from "./ExchangePage.vue?vue&type=template&id=0c73517a&scoped=true"
import script from "./ExchangePage.vue?vue&type=script&lang=js"
export * from "./ExchangePage.vue?vue&type=script&lang=js"
import style0 from "./ExchangePage.vue?vue&type=style&index=0&id=0c73517a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c73517a",
  null
  
)

export default component.exports